// Properties Data Table - matching admin-web structure
import React, { useMemo } from 'react';
import { DataTable } from '@/components';
import { PROPERTY_TABLE_COLUMNS } from './PropertiesDataTableConfig';
import { IPropertyRowData } from '@/types/admin/properties';
import { IDataTableResponse } from '@/types/admin/dataTable';

interface PropertiesDataTableProps {
  data: {
    rows: IPropertyRowData[];
    count: number;
  };
  isLoading: boolean;
  onPropertySelect?: (property: IPropertyRowData) => void;
  updateCsvData?: (data: IPropertyRowData[]) => void;
}

export const PropertiesDataTable: React.FC<PropertiesDataTableProps> = ({
  data,
  isLoading,
  onPropertySelect,
  updateCsvData,
}) => {
  // Transform data to match generic DataTable interface
  const tableData: IDataTableResponse<IPropertyRowData> = useMemo(() => ({
    rows: data.rows || [],
    count: data.count || 0,
  }), [data]);

  const handleRowSelect = (property: IPropertyRowData, index: number) => {
    onPropertySelect?.(property);
  };

  return (
    <DataTable
      data={tableData}
      columns={PROPERTY_TABLE_COLUMNS}
      isLoading={isLoading}
      showSearch={false}
      searchPlaceholder="Search properties..."
      showFilter={true}
      showSort={true}
      onRowSelect={handleRowSelect}
      emptyStateType="property"
    />
  );
};

